export interface IExpertSystemOrderSummary {
    registrationId: number,
    donorId: number,
    donorAlias: string,
    donorName: string,
    donorBirthDate: string,
    donorOrderId: number,
    recipientId: number,
    recipientAlias: string,
    recipientName: string,
    recipientBirthDate: string,
    recipientAbo: string,
    recipientOrderId: number,
    expertSystemId: number,
    centerId: number,
    status: string,
    statusId: number,
    donorTyping: boolean,
    recipientTyping: boolean,
    comments: string,
    donorOrderedKitType: string,
    recipientOrderedKitType: string,
    isInSwap: boolean
}
